/**
 * Shared auth lifecycle decision helpers used by app entrypoints.
 */
export type ResolvedAuthMethod = "legacy" | "auth0" | "none";

type ResolveAuthMethodParams = {
  hasLegacyUser: boolean;
  isAuth0Authenticated: boolean;
};

/**
 * Resolves which auth method should drive app bootstrap.
 */
export function resolveAuthMethod({
  hasLegacyUser,
  isAuth0Authenticated,
}: ResolveAuthMethodParams): ResolvedAuthMethod {
  if (hasLegacyUser) return "legacy";
  if (isAuth0Authenticated) return "auth0";
  return "none";
}
